import { FC, memo } from 'react';
import { LegendItem } from '../common';
import { DonutChartItem } from './types';

type DonutChartLegendProps = {
  data: DonutChartItem[];
};

const DonutChartLegendComp: FC<DonutChartLegendProps> = ({ data }) => (
  <ul className='grid size-fit gap-y-2'>
    {data.map((item) => (
      <LegendItem key={item.name} as={'li'} color={item.color} name={item.name} />
    ))}
  </ul>
);

export const DonutChartLegend = memo(DonutChartLegendComp);
